import * as React from 'react'

import { CmsComponentSlot } from '@grandvisionhq/bloomreach'
import { DownloadInvoiceContainer } from '@grandvisionhq/fun-download-invoice'
import { NextPage } from '@grandvisionhq/next'
import { compose } from '@grandvisionhq/utils'

import { withCms, withLayout } from '../cms'

const DownloadInvoicePage: NextPage = () => (
  <>
    <CmsComponentSlot path="main/top-container" />
    <DownloadInvoiceContainer />
    <CmsComponentSlot path="main/bottom-container" />
  </>
)

export default compose(withCms(), withLayout())(DownloadInvoicePage)
